import React from "react";
import { Page, StyleSheet, Text, Image } from "@react-pdf/renderer";
import Footer from "../components/Footer";
import Table from "../components/Table";
import { Header } from "../components/Header";
import { TransactionProps } from "../../../interfaces/interfaces";
import { useDate } from "../../../hooks";
import checkBoxFill from "../../../assets/utils/check_box_fill.png";
import checkBoxBlank from "../../../assets/utils/check_box_blank.png";

const styles = StyleSheet.create({
  page: {
    padding: 20,
    paddingTop: 20,
    paddingBottom: 80,
  },
  title: {
    fontSize: 20,
    marginBottom: 10,
    textAlign: "right",
    fontFamily: "Times-Roman",
    fontWeight: 800,
    borderBottomColor: "rgb(251,171,53)",
  },
  displayNone: {
    color: "#FFF",
  },
  pushTop: {
    marginTop: 20,
  },
  item: {},
  checkbox: {
    paddingTop: "100px",
    height: 10,
  },
});

export const OrderPdfPage = <T,>({
  orderData,
}: {
  orderData: TransactionProps;
}) => {
  const { getStringFromDate } = useDate();

  return (
    <Page size="A4" orientation="portrait" style={styles.page}>
      <Header />
      <Text style={styles.title}>Order Ticket</Text>
      <React.Fragment>
        <Table>
          <Table.Body>
            {orderData && (
              <>
                <Table.Row>
                  <Table.Cell additionalStyles={styles.displayNone}>
                    0
                  </Table.Cell>
                  <Table.Cell additionalStyles={styles.displayNone}>
                    0
                  </Table.Cell>
                  <Table.Cell>STATUS:</Table.Cell>
                  <Table.Cell>{orderData.Status}</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>RIG NUMBER:</Table.Cell>
                  <Table.Cell>{orderData.RigNumber}</Table.Cell>
                  <Table.Cell>DATE RECEIVED:</Table.Cell>
                  <Table.Cell>
                    {orderData.DateReceived
                      ? getStringFromDate(orderData.DateReceived)
                      : orderData.DateReceived}
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>DRILLING COMPANY:</Table.Cell>
                  <Table.Cell>{orderData.DrillingCompany}</Table.Cell>
                  <Table.Cell>DATE REPAIRED:</Table.Cell>
                  <Table.Cell>{orderData.DateRepaired}</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>INBOUND TRUCKING CO:</Table.Cell>
                  <Table.Cell>{orderData.InboundTruckingCo}</Table.Cell>
                  <Table.Cell>DATE SHIPPED:</Table.Cell>
                  <Table.Cell>{orderData.DateShipped}</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>INBOUND TRUCKING DRIVER:</Table.Cell>
                  <Table.Cell>{orderData.InboundDriver}</Table.Cell>
                  <Table.Cell>SERIAL NUMBER:</Table.Cell>
                  <Table.Cell>{orderData.SerialNumber}</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>OUTBOUND TRUCKING CO:</Table.Cell>
                  <Table.Cell>{orderData.OutboundTruckingCo}</Table.Cell>
                  <Table.Cell>ITEM:</Table.Cell>
                  <Table.Cell>
                    {orderData.ItemDetail ? orderData.ItemDetail.Name : ""}
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>OUTBOUND TRUCKING NAME:</Table.Cell>
                  <Table.Cell>{orderData.OutboundDriver}</Table.Cell>
                  <Table.Cell>CONNECTION:</Table.Cell>
                  <Table.Cell>
                    {orderData.ConnectionDetail
                      ? orderData.ConnectionDetail.Name
                      : ""}
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>NOTES:</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>{orderData.Notes}</Table.Cell>
                </Table.Row>
              </>
            )}
          </Table.Body>
        </Table>
      </React.Fragment>
      <Footer />
    </Page>
  );
};
